module.exports = __webpack_public_path__ + "img/mc_symbol.6727c41c.svg";